import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ConfCallDTO } from './conf-call.dto';

export class ConfCollResponseModel extends GlobalResponseObject {
    data?: ConfCallDTO;
    response: any[];
}
export class AllConfCollResponseModel extends GlobalResponseObject{
    data?: any[];
}